import { render, staticRenderFns } from "./Addresss.vue?vue&type=template&id=03f98dc4&scoped=true"
import script from "./Addresss.vue?vue&type=script&lang=js"
export * from "./Addresss.vue?vue&type=script&lang=js"
import style0 from "./Addresss.vue?vue&type=style&index=0&id=03f98dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f98dc4",
  null
  
)

export default component.exports